import * as service from './calender.service'

export default {
  data() {
    return {
      events: [],
      config: {
        header: {
          right: 'month'
        },
        edit: false,
        editable: false,
        stick: true,
        defaultView: 'month'
      },
      eventDetails: [{
        'ActivityTypeDesc': '',
        'ProgramName': '',
        'Description': '',
        'StartDate': '',
        'EndDate': '',
        'MondayEnd': '',
        'MondayStart': '',
        'TuesdayEnd': '',
        'TuesdayStart': '',
        'WednesdayEnd': '',
        'WednesdayStart': '',
        'ThursdayEnd': '',
        'ThursdayStart': '',
        'FridayEnd': '',
        'FridayStart': '',
        'SaturdayEnd': '',
        'SaturdayStart': '',
        'SundayEnd': '',
        'SundayStart': '',

      }],
      Locations: [],
      Pools: [],
      locationId: '',
      locationName: '',
      poolId: '',

    }
  },

  mounted() {

    let context = this

    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if (context.locationId) {
        context.GetAllSessionsByFilter(this.locationId)
      }

      // alert(JSON.stringify(data))

    })

    this.$router.app.$on('emitTrain', (data) => {
      if (context.locationId) {
        context.GetAllSessionsByFilter(context.locationId)
      }

    })

  },

  methods: {
    eventSelected(event) {

      this.eventDetails = []
      this.eventDetails.push(event.data)
      $('#eventsModel').modal('show')
    },

    GetAllSessionsByFilter(locationid) {
      let context = this

      service.GetAllSessionsByFilter(locationid).then(function (response) {
        context.events = []
        if (response) {

          if (response.length > 0) {

            response.map(function (el) {


              var xt = el.Topic ? ' | Topic: ' + el.Topic : ''
              var xy = el.TrainingName ? 'Training Name: ' + el.TrainingName : ''
              context.events.push({
                title: xy + '' + xt,
                start: context.$moment(el.Date).format('YYYY-MM-DD'),

                data: el,
                allDay: true
              })
            })

          }
        }
      }, (error) => {

      })
    },

  }

}



// WEBPACK FOOTER //
// ./src/components/TrainingCalender/calender.controller.js